import React, { useContext, useReducer, useState, useEffect } from 'react';
import styled from 'styled-components';

import { Typography, Input, InputAdornment } from '@material-ui/core';

import { UserContext } from '../../context/UserState';

import IconEdit from '../../assets/icon-edit.svg';
import BtnPrimary from '../common/BtnPrimary';
import { bsSleep } from '../../utils/manualTimeout';
import CheckboxPrimary from '../common/CheckboxPrimary';

const Root = styled.div`
	h2 {
		margin-bottom: 40px;
		font-size: 24px;
		font-weight: bold;
	}

	.form {
		max-width: 700px;
		margin: 0 auto;

		.form__item {
			display: flex;
			align-items: center;

			&:not(:first-child) {
				border-top: 1px solid white;
			}

			&.has-submit {
				margin-top: 40px;
				justify-content: flex-end;
				border: 0;
			}

			h4 {
				font-size: 16px;
				font-weight: bold;
				line-height: 49px;
				flex: 1 0 33.333333%;
			}

			img {
				width: 20px;
			}

			.MuiInputBase-input {
				padding: 15px 0;
			}

			.MuiInputBase-root.Mui-disabled {
				color: inherit;

				&,
				input {
					cursor: not-allowed;
				}
			}
		}

		.form__checkbox {
			width: 100%;
		}

		.form__error {
			margin: 20px 0 10px 0;
			padding: 20px;
			background-color: ${(props) => props.theme.palette.background.error};
			color: ${(props) => props.theme.palette.text.primary};
			font-size: 16px;
			border-radius: 5px;
		}
	}
`;

function editAccountReducer(state, action) {
	switch (action.type) {
		case 'field': {
			return {
				...state,
				[action.fieldName]: action.payload,
			};
		}
		case 'pushingData': {
			return {
				...state,
				isLoading: true,
			};
		}
		case 'success': {
			return {
				...state,
				isLoading: false,
			};
		}
		case 'error': {
			return {
				...state,
				error: action.error,
				isLoading: false,
			};
		}

		default:
			return state;
	}
}

export default function FormEditAccount() {
	const { user, setUser } = useContext(UserContext);
	const [newsletterCheckbox, setNewsletterCheckbox] = useState(false);
	const [state, dispatch] = useReducer(editAccountReducer, user);
	const { firstNameLastName, companyName, phone, isLoading, error } = state;

	useEffect(() => {
		setNewsletterCheckbox(user.newsletter);
	}, [user.newsletter]);

	const onSubmit = async (e) => {
		e.preventDefault();
		dispatch({ type: 'pushingData' });
		await bsSleep(2000);
		try {
			dispatch({ type: 'success' });
			setUser({
				...user,
				isLoggedIn: true,
				companyName,
				phone,
				firstNameLastName,
				newsletter: newsletterCheckbox,
			});
		} catch (error) {
			dispatch({ type: 'error', error: error.message });
			console.error('error updating userData:', error);
		}
	};

	const formComponent = [
		{
			headlineName: user.username,
			name: 'username',
			placeholder: '',
			disabled: true,
			type: 'text',
		},
		{
			headlineName: 'Name, Vorname',
			name: 'firstNameLastName',
			placeholder: user.firstNameLastName,
			disabled: false,
			type: 'text',
		},
		{
			headlineName: 'Firma',
			name: 'companyName',
			placeholder: user.companyName,
			disabled: false,
			type: 'text',
		},
		{
			headlineName: 'Telefon',
			name: 'phone',
			placeholder: user.phone,
			disabled: false,
			type: 'phone',
		},
		{
			headlineName: 'E-Mail',
			name: 'email',
			placeholder: user.email,
			disabled: true,
			type: 'email',
		},
	];

	return (
		<Root>
			<Typography variant="h2">Benutzerdaten</Typography>
			<form className="form" onSubmit={onSubmit}>
				{error && (
					<div className="form__error">
						<span>{error}</span>
					</div>
				)}
				{formComponent.map((data, index) => (
					<div className="form__item" key={index}>
						<Typography variant="h4">
							{index !== 0 ? data.headlineName : 'Benutzername'}
						</Typography>
						<Input
							name={data.name}
							fullWidth
							disableUnderline
							type={data.type}
							disabled={data.disabled}
							placeholder={
								index !== 0 ? data.placeholder : data.headlineName
							}
							onChange={(e) =>
								dispatch({
									type: 'field',
									fieldName: data.name,
									payload: e.target.value,
								})
							}
							endAdornment={
								<InputAdornment position="end" disablePointerEvents>
									<img
										src={IconEdit}
										alt="Bearbeiten"
										style={{
											display: data.disabled ? 'none' : 'inherit',
										}}
									/>
								</InputAdornment>
							}
						/>
					</div>
				))}
				<div className="form__item">
					<Typography variant="h4">Newsletter</Typography>
					<div className="form__checkbox">
						<CheckboxPrimary
							checked={newsletterCheckbox}
							onChange={(e) => setNewsletterCheckbox(e.target.checked)}
						/>
					</div>
				</div>
				<div className="form__item has-submit">
					<BtnPrimary type="submit" variant="contained" disabled={isLoading}>
						{isLoading ? 'Speichern...' : 'Änderungen speichern'}
					</BtnPrimary>
				</div>
			</form>
		</Root>
	);
}
